// extracted by mini-css-extract-plugin
export default {"btn-holder":"Toggle_btn-holder__+aSrJ","btn-circle":"Toggle_btn-circle__ZcGeq","active":"Toggle_active__QKd9g","checkbox":"Toggle_checkbox__Oo7DX"};